import React from 'react';
import './footer.scss';

const Footer = () => {
  return (
    <footer className="sm-footer--container">
      <div>All set! Now create your own interactive quiz.</div>
    </footer>
  );
};

export default Footer;
